import React from 'react';
import { ChevronDownIcon, ChevronRightIcon } from 'lucide-react';
import { Loan, LoanStage } from '../data/mockData';
import { LoanRow } from './LoanRow';
interface StageSectionProps {
  stage: LoanStage;
  loans: Loan[];
  isExpanded: boolean;
  onToggle: () => void;
}
export const StageSection: React.FC<StageSectionProps> = ({
  stage,
  loans,
  isExpanded,
  onToggle
}) => {
  return <div className="mb-4 bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden transition-colors duration-200" data-id="element-95">
      {/* Section Header */}
      <button onClick={onToggle} className="w-full flex items-center justify-between px-4 py-3 bg-gray-50 dark:bg-gray-800/50 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors border-l-4 border-[#6DB33F] focus:outline-none" data-id="element-96">
        <div className="flex items-center gap-3" data-id="element-97">
          {isExpanded ? <ChevronDownIcon className="w-5 h-5 text-gray-500 dark:text-gray-400 transition-colors duration-200" data-id="element-98" /> : <ChevronRightIcon className="w-5 h-5 text-gray-500 dark:text-gray-400 transition-colors duration-200" data-id="element-99" />}
          <h3 className="font-bold text-gray-800 dark:text-gray-100 text-sm uppercase tracking-wider transition-colors duration-200" data-id="element-100">
            {stage}
          </h3>
        </div>
        <div className="flex items-center gap-4" data-id="element-101">
          <span className="text-sm font-semibold text-gray-700 dark:text-gray-300 transition-colors duration-200" data-id="element-102">
            {new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            maximumFractionDigits: 0
          }).format(loans.reduce((sum, loan) => sum + loan.amount, 0))}
          </span>
          <span className="bg-[#6DB33F]/10 text-[#6DB33F] text-xs font-bold px-2.5 py-1 rounded-full" data-id="element-103">
            {loans.length}
          </span>
        </div>
      </button>

      {/* Expanded Content */}
      {isExpanded && <div className="flex flex-col" data-id="element-104">
          {loans.length > 0 ? <>
              {/* Mini Table Header */}
              <div className="flex items-center py-2 px-4 bg-gray-50 dark:bg-gray-800/50 border-y border-gray-200 dark:border-gray-700 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider transition-colors duration-200" data-id="element-105">
                <div className="w-44 flex-shrink-0 pr-4" data-id="element-106">Borrower</div>
                <div className="w-28 flex-shrink-0 text-right pr-4" data-id="element-107">Amount</div>
                <div className="w-32 flex-shrink-0 pr-4" data-id="element-108">Loan #</div>
                <div className="w-36 flex-shrink-0 pr-4" data-id="element-109">Officer</div>
                <div className="flex-1 pr-4" data-id="element-110">Property</div>
                <div className="w-16 flex-shrink-0 text-center pr-4" data-id="element-111">Days</div>
                <div className="w-64 flex-shrink-0" data-id="element-112">Alerts</div>
              </div>

              {/* Rows */}
              <div className="flex flex-col" data-id="element-113">
                {loans.map((loan, index) => <LoanRow key={loan.id} loan={loan} isStriped={index % 2 !== 0} data-id="element-114" />)}
              </div>
            </> : <div className="py-6 text-center text-sm text-gray-500 dark:text-gray-400 italic border-t border-gray-100 dark:border-gray-700 transition-colors duration-200" data-id="element-115">
              No loans currently in this stage.
            </div>}
        </div>}
    </div>;
};